module.exports = __webpack_public_path__ + "img/logo_vertical.52bef855.svg";